// main.tsx — React app entry point; loads the shared badge chrome and
// mounts <App /> into #root.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Badge chrome (StatusBadge pairing, the sidebar's ButtonBadge rows) before
// the app's own index.css, so the app can still override it.
import 'common/badges.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
